import { InputField, Heading } from "@/common/components";
import { PublicContext } from "@/routes/PublicRoute";
import { useContext } from "react";

const PersonalizedQuestions = ({
  labelOne,
  labelTwo,
  questions,
  setQuestions,
}) => {
  const { labels } = useContext(PublicContext);
  return (
    <section>
      <Heading
        text={"Personalized Security Questions"}
        wrapperClassNames="h4 border-bottom-1 pb-2 mb-3"
        title={false}
      />
      <div className="mb-3">
        <strong>{labels?.updateContactInformation.answerBoth}</strong>
      </div>
      <InputField
        id="firstSecurityQuestion"
        label={labelOne}
        value={questions.questionOne}
        maxLength="40"
        change={(e) =>
          setQuestions({
            ...questions,
            questionOne: e,
          })
        }
      />

      <InputField
        id="secondSecurityQuestion"
        label={labelTwo}
        value={questions.questionTwo}
        maxLength="40"
        change={(e) =>
          setQuestions({
            ...questions,
            questionTwo: e,
          })
        }
        wrapperClassName="mb-4"
      />
    </section>
  );
};

export default PersonalizedQuestions;
